import {Observable} from 'rxjs';
import {Parameter} from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface KeyRoleParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface KeyRole {
    id?: any;   
    name:string; 
    parameters?: KeyRoleParameter[];
    links?: any;
}

export abstract class KeyRoleData {
   
    abstract list(url: string): Observable<KeyRole[]>;
    abstract create(url: string, data: KeyRole): Observable<KeyRole[]>;
    abstract update(url: string, data: KeyRole): Observable<KeyRole>;
    abstract delete(url: string): Observable<any>;
}